import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Link } from 'react-router-dom';

import {
  getRealAge,
  getDivisionDoc,
  getLifterAwardsWeightClassDoc
} from 'util/lifterHelper';

import {
  wilksCoef,
  ageCoef,
  dotsCoef
} from 'util/coefficients';

import {
  getCurrentMeet,
  getLifter,
  getCompleteLiftingOrder
} from 'selectors';

import { getBenchLabel } from 'util/meetHelper';

import './LifterIndex.scss';

class LifterInfo extends Component {

  render() {
    const {
      lifter,
      meet,
      completeLiftingOrder
    } = this.props;

    if(!lifter || !meet) {
      return null;
    }

    const remainingAttempts = _.reject(completeLiftingOrder, (a) => _.get(a, ['attempt', 'result']));
    let out = _.findIndex(remainingAttempts, (a) => _.get(a, ['lifter', '_id']) === lifter._id);
    if(out === -1) {
      out = '';
    }

    const divisions = _.map(lifter.divisions, (lifterDivision) => {
      const divisionDoc =  {...getDivisionDoc(lifterDivision.divisionId, meet)};
      divisionDoc.weightClasses = _.filter(divisionDoc.weightClasses, (w) => {
        const lifterWeightClass = getLifterAwardsWeightClassDoc(meet, lifter, lifterDivision);
        return lifterWeightClass && lifterWeightClass._id === w._id;
      });

      return divisionDoc;
    });

    return (
      <div className="lifter-info">
        <div className="info-row">
          <label>
            Name:
          </label>
          <div>
            {lifter.name}
          </div>
        </div>
        <div className="info-row">
          <label>
            Team:
          </label>
          <div>
            <Link to={`/meets/${_.get(meet, '_id')}/team/${encodeURIComponent(_.get(lifter, 'team'))}`}>{ _.get(lifter, 'team') }</Link>
          </div>
        </div>
        <div className="info-row">
          <label>
            Divisions:
          </label>
          <div>
            {
              _.map(divisions, (d) => {
                return (
                  <div key={d._id}>
                    {d.name} - {_.get(d, ['weightClasses', 0, 'name'])}
                  </div>
                );
              })
            }
          </div>
        </div>
        <div className="info-row">
          <label>
            Platform:
          </label>
          <div>
            <Link to={`/meets/${_.get(meet, '_id')}/platforms/${_.get(lifter, 'platformId')}/board`}>{_.get(meet, ['platforms', lifter.platformId, 'name'])}</Link>
          </div>
        </div>
        <div className="info-row">
          <label>
            Session:
          </label>
          <div>
            {lifter.session}
          </div>
        </div>
        <div className="info-row">
          <label>
            Flight:
          </label>
          <div>
            {lifter.flight}
          </div>
        </div>
        <div className="info-row">
          <label>
            Age:
          </label>
          <div>
            {getRealAge(lifter, meet)}
          </div>
        </div>
        <div className="info-row">
          <label>
            Age Coef:
          </label>
          <div>
            {ageCoef(lifter, meet)}
          </div>
        </div>
        <div className="info-row">
          <label>
            Body Weight:
          </label>
          <div>
            {lifter.bodyWeight} {lifter.bodyWeight &&  <span> {meet.units}</span>}
          </div>
        </div>
        <div className="info-row">
          <label>
            Wilks Coef:
          </label>
          <div>
            {lifter.bodyWeight && _.round(wilksCoef(lifter, meet), 6)}
          </div>
        </div>
        <div className="info-row">
          <label>
            DOTS Coef:
          </label>
          <div>
            {lifter.bodyWeight && _.round(dotsCoef(lifter, meet), 6)}
          </div>
        </div>
        <div className="info-row">
          <label>
            Lot #:
          </label>
          <div>
            {lifter.lot}
          </div>
        </div>
        <div className="info-row">
          <label>
            Squat Rack Height:
          </label>
          <div>
            {lifter.squatRackHeight}
          </div>
        </div>
        <div className="info-row">
          <label>
            {getBenchLabel(meet)} Rack Height:
          </label>
          <div>
            {lifter.benchRackHeight}
          </div>
        </div>
        <div className="info-row">
          <label>
            Attempts Out:
          </label>
          <div>
            {out}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const lifter = getLifter(state, props);
  props = {...props, platformId: lifter.platformId};

  return {
    meet: getCurrentMeet(state, props),
    completeLiftingOrder: getCompleteLiftingOrder(state, props),
    lifter
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(LifterInfo);
